import { createJSONStorage } from "jotai/utils";

/**
 * Jotai storage with per-tab isolation.
 *
 * Uses `sessionStorage` so each tab keeps its own account/workspace state.
 * Falls back to `localStorage` on first read so "open in new tab" still
 * inherits the current context. Writes to both so new tabs always get
 * the latest value.
 */
export const createCrossTabStorage = <T>() =>
  createJSONStorage<T>(() => ({
    getItem: (key) =>
      sessionStorage.getItem(key) ?? localStorage.getItem(key) ?? "",
    setItem: (key, value) => {
      sessionStorage.setItem(key, value);
      localStorage.setItem(key, value);
    },
    removeItem: (key) => {
      sessionStorage.removeItem(key);
      localStorage.removeItem(key);
    },
  }));
